import { useEffect, useState } from 'react';
import { formatDateTime, formatRelativeTime } from '../../lib/dateFormat';

const MINUTE_MS = 60_000;

/** "generated 10min ago", kept current once a minute; the exact time on hover. */
export function GeneratedAt({ at }: { at: string }) {
  // Only this label renders again each minute, not the page.
  const [, setTick] = useState(0);
  useEffect(() => {
    const timer = window.setInterval(() => setTick((n) => n + 1), MINUTE_MS);
    return () => window.clearInterval(timer);
  }, []);
  return (
    <time dateTime={at} title={formatDateTime(at)} className="whitespace-nowrap">
      generated {formatRelativeTime(at)}
    </time>
  );
}
